<p-fieldset legend="Recursos">
  <div class="row">
    <label class="required col-3 col-form-label">
      Houve interposição de recurso?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3" [(ngModel)]="entidade.RecursoNao"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <div class="row mt-2" *ngIf="entidade.RecursoNao === 'S'">
    <div class="col-12">
      <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
        <i class="fa fa-plus"></i> Adicionar
      </button>
    </div>
  </div>
  <table class="table table-eddy table-sm" *ngIf="entidade.RecursoNao === 'S'">
    <thead>
      <tr>
        <th style="width: 35%" scope="col">Documento</th>
        <th style="width: 15%" scope="col">Data da impetração</th>
        <th style="width: 10%" scope="col">Respeitado prazo legal</th>
        <th style="width: 10%" scope="col">Resultado</th>
        <th style="width: 15%" scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of entidade?.Recurso">
        <td style="width: 35%">
          <span *ngIf="!item.editavel && item.CPF">{{item.CPF | CPF}}</span>
          <span *ngIf="!item.editavel && item.CNPJ">{{item.CNPJ | CPF}}</span>
          <span *ngIf="!item.editavel && item.OutroDoc">{{item.OutroDoc}}</span>

          <select *ngIf="item.editavel" class="form-control col-4 float-left" [(ngModel)]="itemAtual.tipoDoc"
            [ngModelOptions]="{standalone: true}">
            <option *ngFor="let item of opcoesDoc" [ngValue]="item">{{item}}</option>
          </select>
          <input *ngIf="item.editavel && itemAtual?.tipoDoc === 'CPF'" type="text" class="form-control col-8 float-right"
            [(ngModel)]="itemAtual.CPF" [ngModelOptions]="{standalone: true}" [imask]="{mask: '000.000.000-00'}"
            unmask="true">
          <input *ngIf="item.editavel && itemAtual?.tipoDoc === 'CNPJ'" type="text"
            class="form-control col-8 float-right" [(ngModel)]="itemAtual.CNPJ" [ngModelOptions]="{standalone: true}"
            [imask]="{mask: '00.000.000/0000-00'}" unmask="true">
          <input *ngIf="item.editavel && itemAtual?.tipoDoc === 'OUTRO'" type="text"
            class="form-control col-8 float-right" [(ngModel)]="itemAtual.OutroDoc"
            [ngModelOptions]="{standalone: true}">
        </td>

        <td style="width: 15%">
          <span *ngIf="!item.editavel">{{item.RecursoDtImpetracao}}</span>
          <p-calendar (onFocus)="onFocusDate()"*ngIf="item.editavel" [(ngModel)]="itemAtual.RecursoDtImpetracao"
            [ngModelOptions]="{standalone: true}" inputStyleClass="form-control" dataType="string" dateFormat="dd/mm/yy"
            [showOnFocus]="true">
          </p-calendar>
        </td>

        <td style="width: 15%">
          <span *ngIf="!item.editavel">{{item.RecursoPrazoLegal}}</span>
          <p-selectButton *ngIf="item.editavel" [options]="opcoesSimNao" optionValue="id" class="col-3 pt-1"
            [(ngModel)]="itemAtual.RecursoPrazoLegal" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </td>

        <td style="width: 15%">
          <span *ngIf="!item.editavel">
            {{item.RecursoResultado}} - {{funcaoService.obterObjetoPorChave(opcoesResultado,
            item.RecursoResultado).nome}}
          </span>
          <select *ngIf="item.editavel" class="form-control" [(ngModel)]="itemAtual.RecursoResultado"
            [ngModelOptions]="{standalone: true}">
            <option *ngFor="let item of opcoesResultado" [ngValue]="item.id">{{item.nome}}</option>
          </select>
        </td>

        <td style="width: 15%" class="text-right">
          <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
          </button>
          <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</p-fieldset>